import { render, staticRenderFns } from "./instant-search-superuser-section.vue?vue&type=template&id=b38675ce&"
import script from "./instant-search-superuser-section.vue?vue&type=script&lang=js&"
export * from "./instant-search-superuser-section.vue?vue&type=script&lang=js&"
import style0 from "./instant-search-superuser-section.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports